<template>
    <div class="users-style">

        <h4 class="atlhr-dashboard-title mt-10 px-0 mb-0">Loan/Advance Notification Settings<span>
            <a v-bind:href="$api_url+'/company/dashboard'">Dashboard</a> / Settings / Loan/Advance Notification Settings</span>
        </h4>


        <div class="row no-margin mt-4"> <!-- Abdullah added this code here  -->
            <div class="ibox col-md-12 px-4"> <!-- Abdullah added this code here  -->
                <b-alert show dismissible fade v-if='successmsg'>{{successmsg}}</b-alert>
                <div class="ibox-title dashboard_title px-0"> <!-- Abdullah added this code here  -->
                    <h4>Loan/Advance Notification Settings</h4>
                </div>

                <div class="ibox-content px-0 pt-4 employee-table-wrapper"> <!-- Abdullah added this code here  -->
                    <div class="row no-gutters py-2 mb-3 pl-0"> <!-- Abdullah added this code here  -->
                        <div class="col-sm-6">
                            <div class="custom-search">
                                 <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search.. " v-model="search" @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>

                         <div class="col-sm-6 pr-0 cursor-pointer text-right company-form-box-title">
                            <b-button @click="saveUserList()">Save User List</b-button>
                        </div>
                    </div>

                     <b-overlay :show="showoverlay" rounded="sm">
                              <table class="table dataTable no-sort-icon">
                        <thead>
                            <tr class="table-head">
                                <td style="text-align: center;"><input type="checkbox" v-model="selectAll" class=""><label class="mb-0 custom-label" style="width: 15px; height: 15px; display: none;"></label></td>
                                <!-- Abdullah added :style="{ fontSize: '16px' }"  -->
                                <td v-for="column in columns" :key="column.name" @click="sortBy(column.name)":class="sortKey === column.name ? (sortOrders[column.name] > 0 ? 'sorting_asc' : 'sorting_desc') : 'sorting'"style="cursor:pointer; font-size: 16px;"><span :style="{ fontSize: '16px' }">{{column.label}}</span></td>
                            </tr>
                        </thead>
                        <tbody>
                            <tr class="hover-bg table-row mx-2" v-for="user in paginatedData" :key="user.id">
                                <td style="text-align: center;"><input type="checkbox" class="justify-content-center" v-model="userids" :value="user.id" number><label class="mb-0 custom-label" style="width: 15px; height: 15px;  display: none;"></label></td>
                                <td>{{user.name}}</td>
                                <td>{{user.email}}</td>
                                <td><template v-if="user.phone">{{formatPhoneNumber(user.phone)}}</template></td>
                                <!--<td>{{assigned[user.assigned].text}}</td>-->
                                <td>{{roles[user.role_id]}}</td>
                            </tr>
                            <!-- <tr v-if="paginatedData.length > 0"><td :colspan="6">
                            <div class="row p-2 float-right" >
                                <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" prev-text="Previous" next-text="Next" base-url="#" first-number last-number ></b-pagination-nav>
                            </div></td></tr>
                            <tr v-if="paginatedData.length == 0"><td :colspan="6">{{blankmsg}}</td></tr> -->
                        </tbody>
                    </table>

                     <div v-if="paginatedData.length == 0" class="px-3 py-3 no-result-cell">{{blankmsg}}</div>
                                <div v-else class="row py-2 no-margin">
                                    <div class="col-md-12 p-0 no-margin">
                                        <ul class="pagination b-pagination float-left mb-0 mt-1">
                                            <li class="page-item disabled m-2">View</li>
                                            <li class="page-item disabled"><b-form-select v-model="temp_length" :options="length_options" @change="setFirstPage()"></b-form-select></li>
                                            <li class="page-item disabled m-2">per page. Total {{pagination.total}} records found.</li>
                                        </ul>
                                        <b-pagination-nav  v-model="pagination.currentPage" :number-of-pages="pagination.pages" base-url="#" prev-text="Previous" next-text="Next" first-number last-number ></b-pagination-nav>
                                    </div>
                                </div>
                     </b-overlay>

                </div>

            </div>
        </div>


        <!-- <div class="mt-4 employee-tab">

            <div class="clearfix company-other-settings">
                <div class="col-md-12 px-3 employee-list-table">
                    <div class="col-sm-6 company-form-box-title mt-3 pl-0 mb-2">Select Users to Send Email Notification</div>
                    <div class="row no-gutters py-2 mb-3 border-bottom">
                        <div class="col-sm-6 pl-0">
                            <div class="company-form-box-title custom-search">
                                <b-input-group class="mb-2">
                                    <b-input-group-prepend is-text>
                                        <b-icon icon="search"></b-icon>
                                    </b-input-group-prepend>
                                    <b-form-input type="search" placeholder="Search Company User" v-model="search" @input="resetPagination()"></b-form-input>
                                </b-input-group>
                            </div>
                        </div>

                    </div>

                </div>
            </div>
        </div> -->
    </div>
</template>

<script>
    export default{

        mounted() {

        },
        props: ['pageurl'],
        data(){

            let sortOrders = {};
            let columns = [
                            {label: 'Name', name: 'name' },
                            {label: 'Email', name: 'email'},
                            {label: 'Phone', name: 'phone'},
                            {label: 'Role', name: 'role_id'},
                        ];
            columns.forEach((column) => {sortOrders[column.name] = -1;});

            return {
                disableme : false,
                users : [],
                companies : [],
                successmsg : null,
                errormsg : [],
                showoverlay : false,
                fdata: {status:null , id:null , user_level:null , assigned:'1' , password:'pass1234' , password_confirmation:'pass1234' , assigned_companies : []},
                pgurl : this.pageurl,
                edit_user : false,
                blankmsg : 'Fetching data..',
                search : '',
                loader : false,

                columns: columns,
                sortKey: 'name',
                sortOrders: sortOrders,
                length : 10,
                pagination : {currentPage: 1,total: '',nextPage: '',prevPage: '',from: '',to: '', pages:1},

                status: [
                    { value: null, text: "Select..." },
                    { value: "1", text: "Active" },
                    { value: "2", text: "Pending" },
                    { value: "3", text: "Not Approved" },
                    { value: "4", text: "Other" },
                ],
                user_level: [
                    { value: null, text: "Select..." },
                    { value: "2", text: "Admin" },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Executive" },
                ],
                assigned: [
                    { value: "0", text: "No" },
                    { value: "1", text: "Yes" },

                ],
                show_user_level: [
                    { value: "0", text: "Select..." },
                    { value: "1", text: "Select..." },
                    { value: "2", text: "Admin" },
                    { value: "3", text: "Manager" },
                    { value: "4", text: "Executive" },
                ],


                roles:[],
                userids:[],
                temp_length:20,
                length_options:
                [
                    { value: 20, text: "20" },
                    { value: 50, text: "50" },
                    { value: 100, text: "100" }
                ],


            }
        },
        methods:{
            getCompanyUsers: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/company/userlist' , {
                    params: {
                        //employee_id: this.employeeId
                    }
                }).then(function(response){
                    //console.log(response.data);
                    this.users = response.data;
                    // Abdullah26 added this
                      this.pagination.total = this.users.length;
                    if(this.users.length == 0){
                        this.blankmsg = "Nothing found.";
                    }
                    else{
                        this.sortBy('name');
                        currentObj.userids = currentObj.users.filter(user => user.email_notification === 'yes').map(user => user.id);
                    }

                }.bind(this)).catch(function (error){currentObj.serverError(error);});
            },
            getRoles: function()
            {
                if(!this.checkNet()) return false;
                let currentObj = this;
                axios.get(this.$api_url+'/acl/role/options/company' , {
                    params: {

                    }
                }).then(function(response){
                    this.roles = response.data;

                }.bind(this)).catch(function (error){
                    //currentObj.serverError(error);
                    });
            },
            validateState(ref)
            {
                if (
                    this.veeFields[ref] &&
                    (this.veeFields[ref].dirty || this.veeFields[ref].validated)
                ) {
                    return !this.veeErrors.has(ref);
                }
                return null;
            },
            saveUserList: function()
            {
                if(!this.checkNet()) return false;
                var msg = "Are you Sure?";
                if(this.userids.length < 1){
                    alert("Please Select users(s).");
                    return false;
                }else{
                    msg = "Do you want to add the selected uers to email notification list?";
                }

                if(confirm(msg)){
                    let currentObj = this;

                    let formData = new FormData();
                    formData.append('userids', this.userids);

                    axios.post(this.$api_url+'/add-notification-users', formData)

                        .then(function (response) {
                            if(response.data.msg){
                                this.$bvToast.toast(response.data.msg, {
                                    title: `Success`,
                                    variant: 'success',
                                    solid: true
                                });
                            }else{
                                this.$bvToast.toast('Error!', {
                                    title: `Error`,
                                    variant: 'danger',
                                    solid: true
                                });
                            }
                            currentObj.getCompanyUsers();
                            currentObj.userids = [];
                        })

                        .catch(function (error) {

                            currentObj.output = error;

                        });
                }
            },
            onSubmit(e)
            {
                if(!this.checkNet()) return false;
                this.$validator.validateAll().then(result => {
                    if (!result) {
                        return;
                    }
                    this.showoverlay = false;
                    this.loader = true;
                    e.preventDefault();
                    let currentObj = this;
                    const config = {
                        headers: { 'content-type': 'multipart/form-data' }
                    }

                    let formData = new FormData();

                    for (let [key, value] of Object.entries(this.fdata))
                    {
                        var nm = `${key}`;
                        var fval = `${value}`;
                        formData.append(nm, fval);
                        //console.log(`${key}: ${value}`);
                    }

                    axios.post(this.$api_url+'/company/saveuser', formData, config)
                                .then(function (response)
                                {
                                    //console.log(response.data);
                                    this.users = response.data;

                                    this.showoverlay = false;
                                    this.loader = false;

                                    this.$bvToast.toast('Saved!', {
                                            title: `Success`,
                                            variant: 'success',
                                            solid: true
                                        });

                                }.bind(this))
                                .catch(function (error)
                                {
                                    currentObj.serverError(error);
                                    currentObj.errormsg = error.response.data.errors;
                                    currentObj.showoverlay = false;
                                    currentObj.loader = false;
                                });
                });
            },

        },
        created: function(){
            this.getCompanyUsers();

            this.getRoles();
            Fire.$on('reloadUsers', () => {this.getCompanyUsers()})
        },
        computed:
        {
            filteredData()
            {
                let filtered_list = this.users;
                if (this.search)
                {
                    filtered_list = filtered_list.filter((row) => {return Object.keys(row).some((key) => {return String(row[key]).toLowerCase().indexOf(this.search.toLowerCase()) > -1;})});

                    if(filtered_list.length == 0)
                        this.blankmsg = "Nothing found.";
                }

                let sortKey = this.sortKey;
                let order = this.sortOrders[sortKey] || 1;
                if (sortKey)
                {
                    filtered_list = filtered_list.slice().sort((a, b) => {let index = this.getIndex(this.columns, 'name', sortKey);
                            a = String(a[sortKey]).toLowerCase();
                            b = String(b[sortKey]).toLowerCase();
                            if (this.columns[index].type && this.columns[index].type === 'date')
                            {
                                return (a === b ? 0 : new Date(a).getTime() > new Date(b).getTime() ? 1 : -1) * order;
                            }
                            else if (this.columns[index].type && this.columns[index].type === 'number')
                            {
                                return (+a === +b ? 0 : +a > +b ? 1 : -1) * order;
                            }
                            else
                            {
                                return (a === b ? 0 : a > b ? 1 : -1) * order;
                            }
                        }
                    );
                }

                return filtered_list;
            },
            paginatedData()
            {
                return this.paginate(this.filteredData, this.length, this.pagination.currentPage);
            },

            selectAll: {
                get: function () {
                    //return this.payslips ? this.payslipids.length == this.payslips.length : false;
                },
                set: function (value) {
                    var userids = [];
                    if (value) {
                        this.users.forEach(function (user) {
                            userids.push(user.id);
                        });
                    }
                    this.userids = userids;
                }
            },
        }
    }
</script>
